import * as React from 'react'

function SvgArrow(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 343.089 343.089'
      {...props}
    >
      <path d='M341.521 167.415a6.79 6.79 0 00-.885-.885L243.46 67.265a7.837 7.837 0 00-13.584 5.225v52.245h-125.91c-4.702 0-9.927 1.045-9.927 5.224v83.592A12.016 12.016 0 00103.966 224h125.91v47.02a8.358 8.358 0 004.702 7.314h3.135a8.362 8.362 0 005.747-2.612l97.176-98.743a6.79 6.79 0 00.885-9.564zM70.531 122.122a7.837 7.837 0 00-7.837 7.837v83.592a7.837 7.837 0 0015.674 0v-83.592a7.837 7.837 0 00-7.837-7.837zM39.184 122.122a7.837 7.837 0 00-7.837 7.837v83.592a7.837 7.837 0 0015.674 0v-83.592a7.837 7.837 0 00-7.837-7.837zM7.837 122.122A7.837 7.837 0 000 129.959v83.592a7.837 7.837 0 0015.674 0v-83.592a7.837 7.837 0 00-7.837-7.837z' />
    </svg>
  )
}

export default SvgArrow
